// removed by extract-text-webpack-plugin
module.exports = {"gray":"hOoB-nkqi_Q9_OKRCmEhn","item":"_5Cbhtt7Ka58x4e0Z2_Fuk","radio":"_4NPdHIB9gqLCUD5LUh9fc"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SingleAuthInfo/SingleAuthInfo.scss
 ** module id = 1038
 ** module chunks = 0
 **/